<template>
    <div>
        <v-app class="p-4">
            <!--        <ads-selector></ads-selector>-->
            <div class="p-0 mt-5 pt-5" style="border: none!important;">
                <categoryselector :editCategory="current" :edit="true" @category-schema="getSchema"
                                  @category-fields="getFields"
                                  ref="category"
                                  :multiAdsCat="false">
                </categoryselector>
                <div class="col-md-11 mx-auto">

                    <div class="col-md-8 mx-auto px-0">
                        <city-selector :defaultEdit="true" :editCity="infos.location" ref="city"
                                       :force="true"></city-selector>
                    </div>
                    <div class="col-md-8 pt-0 mx-auto px-0">
                        <number-selector ref="number" :key="editToken" :editNum="infos.contact.phone" :force="true"
                                         :multiple-numbers="false">
                        </number-selector>
                    </div>
                    <div class="col-md-8 pt-0 mx-auto px-0" v-if="Object.keys(infos).length > 0">
                        <pic-selector :is_edit="true" :editImg="infos.images"></pic-selector>
                    </div>
                </div>

                <div class="px-5 mx-1 pt-0">
                   <call-method :editmode="infos.cantact.call_method" class="col-md-8 mx-auto" v-if="showCall"></call-method>
                    <input-maker ref="inputs" :editField="infos" :param="schema.advertise" :ui_schema="this.ui_schema"
                                 :fields="this.fields"></input-maker>
                </div>

                <setting-ads :edit-mode="infos.contact" class="pr-5"></setting-ads>
                <div class="col-md-8 mr-auto">
                    <v-btn type="submit" class="submit-btn float-left" elevation="8" @click="authenticate">
                        <span class="fa fa-save pr-1" style="font-size: 1.3rem"></span>
                        بروزرسانی آگهی
                    </v-btn>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Categoryselector from "@/view/pages/ads/categorySelector";
import CitySelector from "@/view/pages/ads/citySelector";
import NumberSelector from "@/view/pages/ads/numberSelector";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import SettingAds from "@/view/pages/ads/settingAds";
import inputMaker from "@/view/pages/ads/inputMaker";
import {Bus} from "@/main";
import CallMethod from "../callMethod";

export default {
    name: "editSimple",
    components: {
        CallMethod,
        SettingAds, PicSelector, NumberSelector, CitySelector, Categoryselector, TitleRibbon, inputMaker
    },
    props: {
        ui_schema: {
            type: Array,
            default() {
                return []
            }
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        edit: {
            type: Boolean,
            default: false,
        },
        editToken: {
            type: String,
            default: () => ""
        },
        modal: {
            default: false
        }
    },
    data() {
        return {
            current: '',
            schema: {
                advertise: {
                    category: "",
                    location: {
                        city: "",
                        neighborhood: ""
                    },
                    images: [],
                    contact: {
                        call_method: undefined,
                        chat_enabled: '',
                        hide_phone: '',
                        phone: null
                    },
                },
                available_at: '',
                expire_at: '',
            },
            EditToken: this.editToken,
            infos: [],
            showCall: false,
        }
    },
    methods: {
        getSchema: function (value) {
            this.ui_schema = value;
        },
        getFields: function (val) {
            this.fields = val;
        },
        getadsData() {
            $.ajax({
                url: `${url}/advertise/post/${this.editToken}`,
                type: 'GET',
                fn: this.getadsData,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token
                },
                success: (data) => {
                    this.current = data.data.category;
                    this.infos = data.data;
                    this.schema.advertise = data.data;
                }
            });
        },
        authenticate() {
            this.$modal.showLoading();
            $.ajax({
                url: `${url}/divar/check/title`,
                type: "POST",
                fn: this.authenticate,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                data: JSON.stringify({
                    "title": this.schema.advertise['title'],
                    "city": String(this.schema.advertise.location.city),
                    "category": this.schema.advertise.category
                }),
                msg: false,
                error: (data) => {
                    if (data.status === 422) {
                        this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
                    } else {
                        this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
                    }
                },
                success: (data) => {
                    this.updateAds();
                }
            });

        },
        updateAds() {
            const data = this.schema;

            if (!this.$refs.inputs.validate() || !this.$refs.number.validate() || !this.$refs.city.validate())
                return;

            if (data.available_at === "" || !data.available_at) {
                delete data.available_at;
            }

            if (data.expire_at === "" || !data.expire_at) {
                delete data.expire_at;
            }

            $.ajax({
                url: `${url}/divar/advertise/update/${this.editToken}`,
                method: 'PUT',
                fn: this.updateAds,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Token,
                    ACCEPT: 'application/json'
                },
                msg: true,
                data: JSON.stringify(data),
                success: () => {
                    this.infos = [];
                    this.modal();
                },
            })
        }
    },
    watch: {
        infos() {
            setTimeout(() => {
                Bus.$emit('getBreadCrumb', 10);
            }, 1000)
        },
        editToken() {
            this.getadsData()
        },
        current(val) {
            if (val === "shoes-belt-bag" || val === "clothing-and-shoes" || val === "clothing") {
                {
                    this.showCall = true
                }
            } else {
                this.showCall = false
            }
        }
    },
    mounted() {
        Bus.$on('category-current', (value) => {
            this.schema.advertise.category = value;
        });

        Bus.$on('cityInfo', (value) => {
            this.schema.advertise.location.city = value.city;
            if (value.neighborhood === '')
                delete this.schema.advertise.location.neighborhood;
            else
                this.schema.advertise.location.neighborhood = value.neighborhood;
        });

        Bus.$on('callMethod', (value) => {
            if (this.current === "shoes-belt-bag" || this.current === "clothing-and-shoes" || this.current === "clothing") {
                this.schema.advertise.contact.call_method = value;
            } else
                this.schema.advertise.contact.call_method = undefined;

        });

        Bus.$on('contact', (value) => {
            this.schema.advertise.contact.chat_enabled = value.chat_enabled;
            this.schema.advertise.contact.hide_phone = value.hide_phone;
            this.schema.auto_pay = value.autoPay;
        });

        Bus.$emit('editCategory', this.current);

        Bus.$on('selected_numbers', (value) => {
            this.schema.advertise.contact.phone = value
        });

        Bus.$on('selectedImage', (value) => {
            this.schema.advertise.images = value;
        });
        Bus.$on('parameters', (value) => {
            this.schema.advertise = value;
        });

        this.getadsData();
    }

}
</script>

<style scoped>

</style>